<template>
  <q-dialog
    :value="value"
    position="right"
    full-height
    content-class="mobile-menu"
    square
    @input="$emit('input', $event)"
  >
    <q-card style="width: var(--menu-width)">
      <q-toolbar style="height: var(--header-height)" class="justify-between">
        <q-btn
          round
          flat
          @click="user"
        >
          <q-avatar size="33px" v-html="iconAva" />
        </q-btn>

        <q-btn
          v-close-popup
          flat
          round
          dense
          icon="close"
        />
      </q-toolbar>

      <q-scroll-area class="mobile-menu__scroll-area">
        <q-card-section class="q-pa-none">
          <div
            v-for="m in menu"
            :key="m.title"
            class="layout-menu-item"
            :class="{active: isActive(m.path) }"
            @click="menuHandler(m)"
          >
            <div
              class="layout-menu-item-icon"
              v-html="m.icon"
            />
            <div class="layout-menu-item-title">
              {{ m.title }}
            </div>
          </div>
        </q-card-section>

        <q-separator />

        <q-card-section class="q-pa-none">
          <div
            class="layout-menu-item"
            @click="logout"
          >
            <div
              class="layout-menu-item-icon"
              v-html="iconExit"
            />
            <div class="layout-menu-item-title">
              Выход
            </div>
          </div>
        </q-card-section>
      </q-scroll-area>
    </q-card>
  </q-dialog>
</template>

<script>
import iconAva from 'Images/icon/ava.svg'
import iconExit from 'Images/icon/exit.svg'
import { AuthenticationService } from '../../../api/auth'
import { notify } from 'Utils/notify'

export default {
  props: {
    menu: Array,
    value: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    toolbar: true,
    iconAva,
    iconExit,
    authService: new AuthenticationService()

  }),
  computed: {
    currentPage: {
      get() {
        return this.$route.fullPath
      },
      set(newPath) {
        return newPath
      }
    }
  },
  methods: {
    menuHandler(m) {
      this.currentPage = m.path;
      this.$router.push(m.path)
      this.$emit('input', false)
    },
    /**
     * Стравнивает значение пункта меню с текущей страницей
     * @function
     * @param {String} page - пункт меню
     * */
    isActive(page) {
      return page === this.currentPage
    },
    /**
     * Заглушка для перехода на страницу пользователя
     * @function
     * */
    user() {
      notify({
        text: 'User'
      })
    },
    logout() {
      this.authService.logout()
      this.$router.push({path:'/auth'})
    }
  }
}
</script>

<style lang="scss">
.mobile-menu {
  .q-dialog__inner {
    padding: 0;
  }

  .mobile-menu__scroll-area {
    height: calc(100% - var(--header-height));
  }
}
</style>
